import { createFileRoute, redirect } from "@tanstack/react-router";
import { templateSettingsSchema } from "@patient-watch/types";
import { newTemplatesSearchSchema } from "@/routes/_app/templates/index";

const nameSearchSchema = templateSettingsSchema.partial();

/** Legacy route: name / description are taken from the wizard search params and the flow finishes on Contact. */
export const Route = createFileRoute("/_app/templates/$templateId/name")({
    component: () => null,
    validateSearch: (search) => nameSearchSchema.parse(search),
    beforeLoad: () => {
        throw redirect({
            to: "/templates",
            search: newTemplatesSearchSchema.parse({}),
            replace: true,
        });
    },
});
